import { FiltersConfig } from '@crx-dev/hss-react-components';

export const filtersConfig: FiltersConfig = [
    {
        type: 'date-range',
        label: 'Date Filter',
        name: 'dateRange'
        // description: 'Optional description'
    },
    {
        type: 'multi-select',
        label: 'Entry Type',
        name: 'entryTypes',
        values: [
            { value: 'Supplied', label: 'Supplied' },
            { value: 'Received', label: 'Received' },
            { value: 'Destroyed', label: 'Destroyed' },
            { value: 'Amendment', label: 'Amendment' },
            { value: 'StockCheck', label: 'Stock Check' },
            { value: 'Quarantined', label: 'Expired Stock' }
        ]
        // description: 'Optional description'
    }
];
